var handleApiError = function handleApiError(e) {
  var _e$response;
  var data = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data;
  if (data !== null && data !== void 0 && data.message) {
    return {
      message: data.message
    };
  }
  if ((data === null || data === void 0 ? void 0 : data.error) === 'not_found') {
    return {
      message: 'The requested resource cannot be found'
    };
  }
  if ((data === null || data === void 0 ? void 0 : data.error) === 'forbidden') {
    return {
      message: 'You are not authorised to perform this action, please contact the administrator'
    };
  }
  if ((data === null || data === void 0 ? void 0 : data.error) === 'unauthorized') {
    return {
      message: 'Your session has expired, please reload your tab to re-authenticate.'
    };
  }
  if (data !== null && data !== void 0 && data.error_description) {
    return {
      message: data.error_description
    };
  }
  return {
    message: 'Something went wrong, please try again or check your internet.'
  };
};
export default handleApiError;